// @flow
import React from 'react';
import { Iframe } from './elements/DashboardElements';

type Props = {
  src: string,
};

export const EmbeddedIframe = ({ src }: Props) => <Iframe src={src} />;
